<template>
    <div v-if="labels.length" class="ob-nav">
        <v-btn text color="txtSecondary" class="ob-nav-btn text-lowercase" @click="$emit('back')">
            {{ $t('common.back') }}
        </v-btn>
        <div class="ob-steps">
            <div v-for="(label, i) in labels" :key="i" class="ob-step"
                :class="{ active: step === i + 1, done: step > i + 1 }">
                <div class="ob-step-circle">
                    <v-icon v-if="step > i + 1" size="16" color="#fff">mdi-check</v-icon>
                    <template v-else>{{ i + 1 }}</template>
                </div>
                <span class="ob-step-label">{{ label }}</span>
            </div>
        </div>
        <v-btn v-if="canSkip" text color="txtSecondary" class="ob-nav-btn text-lowercase" @click="$emit('skip')">
            {{ $t('common.skip') }}
        </v-btn>
    </div>

    <v-row v-else class="container-steps">
        <v-col cols="3" align="left">
            <v-btn color="accent" text small @click="$emit('back')" class="normal-btn">
                {{ $t('common.back') }}
            </v-btn>
        </v-col>
        <v-col cols="6" align="center">
            <v-rating :value="step" x-small readonly full-icon="mdi-circle" empty-icon="mdi-circle-outline"
                color="secondary" />
        </v-col>
        <v-col cols="3" align="right">
            <v-btn v-if="canSkip" color="accent" text small @click="$emit('skip')" class="text-lowercase">
                {{ $t('common.skip') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "StepDots",
    props: {
        step: {
            type: [String, Number],
            default: 0,
        },
        canSkip: {
            type: Boolean,
            default: false,
        },
        labels: {
            type: Array,
            default: () => [],
        }
    }
}
</script>

<style scoped>
.container-steps {
    position: sticky;
    top: 48px;
    margin-bottom: 48px;
    z-index: 1;
    background-color: #ffffff;
}

.ob-nav {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 0 0 20px;
}

.ob-nav-btn {
    flex-shrink: 0;
    min-width: 0 !important;
    height: auto !important;
    padding: 0 !important;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: normal;
    border-radius: 0;
}

.ob-steps {
    display: flex;
    align-items: flex-start;
    flex: 1;
}

.ob-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;
}

.ob-step:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 14px;
    left: calc(50% + 14px);
    right: calc(-50% + 14px);
    height: 1.5px;
    background: var(--v-outline-base);
    transition: background .3s ease;
}

.ob-step.done:not(:last-child)::after {
    background: var(--v-secondary-base);
}

.ob-step-circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1.5px solid var(--v-outline-base);
    background: var(--v-surface-base);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    transition: all .25s ease;
    position: relative;
    z-index: 1;
    flex-shrink: 0;
}

.ob-step.done .ob-step-circle {
    background: var(--v-secondary-base);
    border-color: var(--v-secondary-base);
    color: #fff;
}

.ob-step.active .ob-step-circle {
    background: var(--v-surface-base);
    border: 2px solid var(--v-secondary-base);
    color: var(--v-accent-base);
    box-shadow: 0 0 0 4px rgba(102, 204, 204, 0.15);
}

.ob-step-label {
    display: block;
    font-size: 9px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-top: 4px;
    text-align: center;
}

.ob-step.active .ob-step-label {
    color: var(--v-accent-base);
}

.ob-step.done .ob-step-label {
    color: var(--v-secondary-base);
}
</style>
